import { h, Fragment } from "preact";

import CardTemplate from "../Common/CardTemplate";
import ButtonWithTooltipAndBadge from "../Common/ButtonWithTooltipAndBadge";
import FilePresentIcon from '@mui/icons-material/FilePresent';
import {

    Box,
    Chip,

    Typography,

} from "@mui/material";


export default function Dataroomcard({ id, stats, flag }) {

    return (
        <CardTemplate
            title="Dossier de vente"
            buttons={
                <ButtonWithTooltipAndBadge
                    tooltip="Consulter les documents à fournir"
                    icon={<FilePresentIcon />}
                    onclick_cb={() => {
                        window.location.href = "/dataroom/" + id;
                    }}
                    badge={flag} />
            }

            content={
                <Fragment>
                    <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                        <Box >
                            <Typography variant="h5">Biens</Typography>
                        </Box>
                        <Box p={1}>
                            <Chip
                                size="small"
                                color={stats.re_docs_ok ? "success" : "warning"}
                                label={stats.re_docs_ok ? "Complets" : "Incomplets"}
                            />
                        </Box>

                    </Box>

                    <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                        <Box>
                            <Typography variant="h5">Vendeurs</Typography>
                        </Box>
                        <Box p={1}>
                            <Chip
                                size="small"
                                color={stats.vn_docs_ok ? "success" : "warning"}
                                label={stats.vn_docs_ok ? "Complets" : "Incomplets"}
                            />
                        </Box>


                    </Box>

                    {stats.dude_ac.length > 0 && <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                        <Box >
                            <Typography variant="h5">Acquéreurs</Typography>
                        </Box>
                        <Box p={1}>
                            <Chip
                                size="small"
                                color={stats.aq_docs_ok ? "success" : "warning"}
                                label={stats.aq_docs_ok ? "Complets" : "Incomplets"}
                            />
                        </Box>

                    </Box>}
                </Fragment>
            }
        />)

}

